<template>
  <div class="container-fluid">
    <div class="m-2">
      <div class="alert alert-primary">
        <div class="h4 text-center">
          <linkto :link="'/categories'"/>
          Új kategória rögzítés
        </div>
      </div>
    </div>
  	<div class="row d-flex justify-content-center">
  		<div class="col-12">
  			<div class="row d-flex justify-content-center align-items-center">
  				<catdata
  					:change="false"
  				>
  				</catdata>
  			</div>
  		</div>
  	</div>
  </div>
</template>

<script>
import catdata from './category_data'
export default {
  name: 'new_category',
  components: {
  	catdata
  }
  
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/categories/new_category.vue